// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1U9UM","inputWrap":"styles_inputWrap__V8adG","input":"styles_input__2vFCv"};